import * as c from './components';



export namespace Hidden {
    export import Accessibly = c.AccessiblyHidden;

    export import Fully = c.FullyHidden;

    export import Visually = c.VisuallyHidden;
}